/**
 * Is this key event coming from somewhere the player is TYPING?
 *
 * Hotkeys are registered on `window`, so they fire even while a text field has focus.
 * That made the feedback form unusable: Space started the next wave instead of typing a
 * space, so everything the player wrote came out as one long run-on word. Space was only
 * the visible half — `r` rerolled the shop and the number keys bought towers and fired
 * support surges, so typing "rare" spent gold twice mid-sentence.
 *
 * Checked against the event TARGET rather than tracked as "is a field focused" state,
 * because the target is the truth at the moment the key was pressed and needs nothing
 * kept in sync.
 */
export function isTypingTarget(target: EventTarget | null): boolean {
  const el = target as (HTMLElement & { tagName?: unknown }) | null;
  if (!el || typeof el.tagName !== 'string') return false;
  const tag = el.tagName.toUpperCase();
  // SELECT is in the list for the same reason: letters jump between its options and the
  // arrows move the selection, so a dropdown is being "typed into" too.
  return (
    tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable === true
  );
}
